// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import ChangePasswordDialog from '../dialogs/ChangePasswordDialog';
import i18n from '../../i18n';
import { MenuItem } from '@mui/material';
import PasswordIcon from '@mui/icons-material/Password';
import config from '../../config';
import { getModifiedBy, getUserNameByRole } from '../../utils/cells';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class UsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'users';
        this.Server = this.props.context.getState().server.users;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['firstName', 'lastName'];

        const defaultHead = [
            {
                id: 'firstName',
                label: 'firstName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'lastName',
                label: 'lastName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'role',
                label: 'role',
                alignRight: false,
                cell: 'RoleSelect',
                show: 'name',
                from: 'roles',
                object: 'role',
                fullObject: true,
                // translate: 'enums',
                // needTranslate: (value) => value?.isDefault, // maybe used in future
                displayGrid: true,
                extraRender: (value, row) => getUserNameByRole(value, row)
                // enableCopyExtraRender: true,
            },
            {
                id: 'merchantId',
                label: 'merchant',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                object: 'merchant',
                displayGrid: false,
                from: 'publicMerchants',
                showIfDialog: (data) =>
                    data.role?.systemRole ===
                        config.roles.merchant.systemRole ||
                    data.role?.systemRole === config.roles.appz.systemRole
            },
            {
                id: 'providerId',
                label: 'provider',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicProviders',
                object: 'provider',
                displayGrid: false,
                showIfDialog: (data) =>
                    data.role?.systemRole === config.roles.psp.systemRole ||
                    data.role?.systemRole === config.roles.appz.systemRole
            },
            {
                id: 'agentId',
                label: 'agent',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicAgents',
                object: 'agent',
                displayGrid: false,
                showIfDialog: (data) =>
                    data.role?.systemRole === config.roles.agent.systemRole ||
                    data.role?.systemRole === config.roles.appz.systemRole
            },
            {
                id: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'twoFactorEnabled',
                label: 'twoFactorAuth',
                alignRight: false,
                cell: 'Enable',
                type: 'boolean',
                role: 'admin_ecoo',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                displayGrid: true
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head,
            changePassDialogOpen: false,
            activeUserId: null
        };
    }

    openChangePassDialog() {
        this.handleCloseMenu();
        this.setState({
            changePassDialogOpen: true,
            activeUserId: this.state.menuClickItemId
        });
    }

    renderCustomMenuItems() {
        return (
            <MenuItem onClick={() => this.openChangePassDialog()}>
                <PasswordIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.changePass')}
            </MenuItem>
        );
    }

    renderCustom() {
        return (
            <ChangePasswordDialog
                open={this.state.changePassDialogOpen}
                userId={this.state.activeUserId}
                onClose={() =>
                    this.setState({
                        changePassDialogOpen: false,
                        activeUserId: null
                    })
                }
            />
        );
    }
}
